import { useState } from 'react';
import { Typography } from 'mobily-ui-library/lib';

import Loader from './components/Loader/Loader';
import DeviceLoginForm from './components/DeviceLogin/DeviceLoginForm';
import ResourceEnvironment from './hook/ResourceEnvironment';
import { DAPIClientToken, ApigeeClientToken } from './hook/Token';

import './App.scss';

interface Props {
  rtl: boolean;
}

function App({ rtl }: Props) {
  const [env, setEnv] = useState(false);
  const [dapiToken, setDAPIToken] = useState(false);
  const [apigeeToken, setApigeeToken] = useState(false);
  const [loading, setLoading] = useState(false);

  return (
    <>
      <ResourceEnvironment setEnv={setEnv} />
      <DAPIClientToken setDAPIToken={setDAPIToken} />
      <ApigeeClientToken setApigeeToken={setApigeeToken} />

      {(env && apigeeToken && dapiToken) && (
        <section className={rtl ? "container DeviceLogin__Container DL__Right" : "container DeviceLogin__Container"}>
          <Loader loading={loading} />
          <Typography rtl={rtl} className='heading'>Contact information</Typography>
          <DeviceLoginForm rtl={rtl} setLoading={setLoading} />
        </section>
      )}
    </>
  );
}

export default App;
